export default [{
    "date": 1485545056638,
    "row": 44,
    "col": 19,
    "squares": [
        [2, 5, "#FF0000"],
        [2, 7, "#FF0000"],
        [3, 4, "#FF0000"],
        [3, 5, "#FF0000"],
        [3, 6, "#FF0000"],
        [3, 7, "#FF0000"],
        [3, 8, "#FF0000"],
        [4, 4, "#FF0000"],
        [4, 5, "#FF0000"],
        [4, 6, "#FF0000"],
        [4, 8, "#FF0000"],
        [4, 9, "#FF0000"],
        [5, 5, "#FF0000"],
        [5, 9, "#FF0000"],
        [6, 9, "#FF0000"],
        [7, 9, "#FF0000"],
        [8, 9, "#FF0000"],
        [9, 9, "#FF0000"],
        [9, 8, "#FF0000"],
        [9, 10, "#FF0000"],
        [10, 7, "#FF0000"],
        [10, 8, "#FF0000"],
        [10, 9, "#FF0000"],
        [10, 10, "#FF0000"],
        [10, 11, "#FF0000"],
        [11, 6, "#FF0000"],
        [11, 7, "#FF0000"],
        [11, 8, "#FF0000"],
        [11, 9, "#FF0000"],
        [11, 10, "#FF0000"],
        [11, 11, "#FF0000"],
        [12, 6, "#FF0000"],
        [13, 6, "#FF0000"],
        [14, 6, "#FF0000"],
        [12, 7, "#FF0000"],
        [12, 9, "#FF0000"],
        [12, 8, "#FF0000"],
        [12, 10, "#FF0000"],
        [12, 11, "#FF0000"],
        [13, 12, "#FF0000"],
        [13, 11, "#FF0000"],
        [13, 9, "#FF0000"],
        [13, 7, "#FF0000"],
        [6, 7, "#000000"],
        [7, 7, "#000000"],
        [10, 6, "#000000"],
        [9, 6, "#000000"],
        [9, 5, "#000000"],
        [8, 5, "#000000"],
        [9, 4, "#000000"],
        [10, 4, "#000000"],
        [6, 5, "#808000"],
        [7, 5, "#808000"],
        [7, 4, "#808000"],
        [8, 4, "#808000"],
        [5, 4, "#808000"],
        [6, 4, "#808000"],
        [6, 3, "#808000"],
        [7, 3, "#808000"],
        [8, 3, "#808000"],
        [9, 3, "#808000"],
        [14, 5, "#FF0000"],
        [15, 5, "#FF0000"],
        [16, 5, "#FF0000"],
        [17, 5, "#FF0000"],
        [18, 5, "#FF0000"],
        [19, 5, "#FF0000"],
        [20, 5, "#FF0000"],
        [21, 5, "#FF0000"],
        [20, 6, "#FF0000"],
        [19, 6, "#FF0000"],
        [21, 6, "#FF0000"],
        [22, 6, "#FF0000"],
        [23, 6, "#FF0000"],
        [24, 6, "#FF0000"],
        [25, 7, "#FF0000"],
        [24, 7, "#FF0000"],
        [23, 7, "#FF0000"],
        [22, 7, "#FF0000"],
        [21, 7, "#FF0000"],
        [20, 7, "#FF0000"],
        [26, 8, "#FF0000"],
        [25, 8, "#FF0000"],
        [24, 8, "#FF0000"],
        [23, 8, "#FF0000"],
        [27, 9, "#FF0000"],
        [26, 9, "#FF0000"],
        [27, 10, "#FF0000"],
        [28, 10, "#FF0000"],
        [28, 11, "#FF0000"],
        [29, 11, "#FF0000"],
        [29, 12, "#FF0000"],
        [30, 12, "#FF0000"],
        [31, 12, "#FF0000"],
        [32, 12, "#FF0000"],
        [30, 13, "#FF0000"],
        [31, 13, "#FF0000"],
        [32, 13, "#FF0000"],
        [33, 13, "#FF0000"],
        [34, 13, "#FF0000"],
        [35, 13, "#FF0000"],
        [31, 14, "#FF0000"],
        [33, 14, "#FF0000"],
        [32, 14, "#FF0000"],
        [34, 14, "#FF0000"],
        [35, 14, "#FF0000"],
        [36, 14, "#FF0000"],
        [32, 15, "#FF0000"],
        [33, 15, "#FF0000"],
        [34, 15, "#FF0000"],
        [35, 15, "#FF0000"],
        [36, 15, "#FF0000"],
        [37, 15, "#FF0000"],
        [38, 15, "#FF0000"],
        [39, 15, "#FF0000"],
        [37, 16, "#FF0000"],
        [38, 16, "#FF0000"],
        [39, 16, "#FF0000"],
        [40, 16, "#FF0000"],
        [41, 16, "#FF0000"],
        [42, 16, "#FF0000"],
        [43, 17, "#FF0000"],
        [42, 17, "#FF0000"],
        [41, 17, "#FF0000"],
        [40, 17, "#FF0000"],
        [42, 18, "#800000"],
        [41, 18, "#800000"],
        [40, 18, "#800000"],
        [39, 18, "#800000"],
        [39, 17, "#800000"],
        [38, 17, "#800000"],
        [37, 17, "#800000"],
        [36, 17, "#800000"],
        [36, 16, "#800000"],
        [35, 16, "#800000"],
        [34, 16, "#800000"],
        [33, 16, "#800000"],
        [32, 16, "#800000"],
        [31, 16, "#800000"],
        [31, 15, "#800000"],
        [30, 15, "#800000"],
        [30, 14, "#800000"],
        [29, 14, "#800000"],
        [31, 17, "#0000FF"],
        [30, 17, "#0000FF"],
        [32, 18, "#0000FF"],
        [31, 18, "#0000FF"],
        [30, 16, "#0000FF"],
        [29, 16, "#0000FF"],
        [29, 15, "#0000FF"],
        [28, 15, "#0000FF"],
        [28, 14, "#0000FF"],
        [27, 14, "#0000FF"],
        [29, 13, "#0000FF"],
        [28, 13, "#0000FF"],
        [28, 12, "#0000FF"],
        [27, 12, "#0000FF"],
        [27, 11, "#0000FF"],
        [26, 11, "#0000FF"],
        [26, 10, "#0000FF"],
        [25, 10, "#0000FF"],
        [25, 9, "#0000FF"],
        [24, 9, "#0000FF"],
        [21, 8, "#00FFFF"],
        [22, 8, "#00FFFF"],
        [22, 9, "#00FFFF"],
        [23, 9, "#00FFFF"],
        [23, 10, "#00FFFF"],
        [24, 10, "#00FFFF"],
        [24, 11, "#00FFFF"],
        [25, 11, "#00FFFF"],
        [25, 12, "#00FFFF"],
        [26, 12, "#00FFFF"],
        [27, 13, "#00FFFF"],
        [26, 13, "#00FFFF"],
        [26, 14, "#00FFFF"],
        [25, 14, "#00FFFF"],
        [25, 13, "#00FFFF"],
        [24, 13, "#00FFFF"],
        [24, 12, "#00FFFF"],
        [23, 12, "#00FFFF"],
        [23, 14, "#00FFFF"],
        [24, 14, "#00FFFF"],
        [27, 15, "#00FFFF"],
        [26, 15, "#00FFFF"],
        [25, 15, "#00FFFF"],
        [24, 15, "#00FFFF"],
        [28, 16, "#00FFFF"],
        [27, 16, "#00FFFF"],
        [26, 16, "#00FFFF"],
        [25, 16, "#00FFFF"],
        [29, 17, "#00FFFF"],
        [28, 17, "#00FFFF"],
        [27, 17, "#00FFFF"],
        [26, 17, "#00FFFF"],
        [30, 18, "#00FFFF"],
        [29, 18, "#00FFFF"],
        [28, 9, "#808080"],
        [29, 9, "#808080"],
        [29, 10, "#808080"],
        [30, 10, "#808080"],
        [29, 8, "#808080"],
        [30, 8, "#808080"],
        [15, 6, "#008080"],
        [16, 6, "#008080"],
        [17, 6, "#008080"],
        [18, 6, "#008080"],
        [19, 7, "#008080"],
        [18, 7, "#008080"],
        [17, 7, "#008080"],
        [16, 7, "#008080"],
        [15, 7, "#008080"],
        [14, 7, "#008080"],
        [20, 8, "#008080"],
        [19, 8, "#008080"],
        [18, 8, "#008080"],
        [17, 8, "#008080"],
        [16, 8, "#008080"],
        [15, 8, "#008080"],
        [13, 8, "#FFFF00"],
        [14, 8, "#FFFF00"],
        [14, 9, "#FFFF00"],
        [15, 9, "#FFFF00"],
        [13, 10, "#FFFF00"],
        [14, 10, "#FFFF00"],
        [14, 11, "#FFFF00"],
        [15, 11, "#FFFF00"],
        [15, 12, "#FFFF00"],
        [16, 12, "#FFFF00"],
        [14, 12, "#FF0000"],
        [16, 9, "#008080"],
        [15, 10, "#008080"],
        [16, 10, "#008080"],
        [16, 11, "#008080"],
        [17, 11, "#008080"],
        [17, 12, "#008080"],
        [17, 13, "#008080"],
        [16, 13, "#008080"],
        [18, 13, "#008080"],
        [19, 13, "#008080"],
        [19, 14, "#008080"],
        [20, 14, "#008080"],
        [21, 14, "#008080"],
        [22, 14, "#008080"],
        [22, 15, "#008080"],
        [23, 15, "#008080"],
        [23, 13, "#008080"],
        [22, 13, "#008080"],
        [21, 13, "#008080"],
        [20, 13, "#008080"],
        [22, 12, "#008080"],
        [21, 12, "#008080"],
        [20, 12, "#008080"],
        [19, 12, "#008080"],
        [18, 12, "#008080"],
        [23, 11, "#008080"],
        [22, 11, "#008080"],
        [21, 11, "#008080"],
        [20, 11, "#008080"],
        [19, 11, "#008080"],
        [18, 11, "#008080"],
        [17, 9, "#008080"],
        [17, 10, "#008080"],
        [18, 9, "#008080"],
        [18, 10, "#008080"],
        [19, 9, "#008080"],
        [19, 10, "#008080"],
        [20, 9, "#008080"],
        [20, 10, "#008080"],
        [21, 9, "#008080"],
        [21, 10, "#008080"],
        [22, 10, "#008080"],
        [30, 9, "#800000"],
        [31, 8, "#800000"],
        [32, 7, "#800000"],
        [31, 9, "#800000"],
        [32, 8, "#800000"],
        [33, 7, "#800000"],
        [33, 6, "#800000"],
        [34, 6, "#800000"],
        [34, 5, "#800000"],
        [35, 5, "#800000"],
        [35, 4, "#800000"],
        [24, 16, "#800000"],
        [23, 16, "#800000"],
        [23, 17, "#800000"],
        [22, 17, "#800000"],
        [22, 18, "#800000"],
        [21, 18, "#800000"],
        [20, 19, "#800000"],
        [21, 19, "#800000"],
        [36, 4, "#800000"],
        [36, 3, "#800000"],
        [37, 3, "#800000"],
        [37, 2, "#800000"],
        [38, 2, "#800000"],
        [38, 1, "#800000"],
        [39, 1, "#800000"]
    ]
}, ]
